<wbo-edit-page #editPage [title]="model.data.name">
    <fui-formation-group [title]="'wbo.extra.edit.formation.details'" [formControlNames]="''">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name">
                        </wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="externalName" [(ngModel)]="model.data.externalName">
                        </wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="selectionMessage" [(ngModel)]="model.data.selectionMessage">
                        </wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-numeric-edit-control formControlName="groupQtyMin" [digitInfo]="'1.0-0'"
                                                      [(ngModel)]="model.data.groupQtyMin">
                            </wbo-numeric-edit-control>
                            <wbo-numeric-edit-control formControlName="groupQtyLimit" [digitInfo]="'1.0-0'"
                                                      (valueChange)="updateValueAndValidity(['groupQtyMin'])"
                                                      [(ngModel)]="model.data.groupQtyLimit">
                            </wbo-numeric-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column>
                        <fui-prepend-field>
                            <wbo-checkbox-edit-control formControlName="promoted" [(ngModel)]="model.data.promoted">
                            </wbo-checkbox-edit-control>
                            <wbo-text-edit-control *ngIf="model.data.promoted" formControlName="promotionMessage"
                                                   [(ngModel)]="model.data.promotionMessage">
                            </wbo-text-edit-control>
                        </fui-prepend-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-currency-edit-control formControlName="totalIncluded"
                                                   [(ngModel)]="model.data.totalIncluded"
                                                   (valueChange)="totalIncludedChange()">
                        </wbo-currency-edit-control>
                    </fui-column>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-checkbox-edit-control formControlName="conversational"
                                                       [(ngModel)]="model.data.conversational">
                            </wbo-checkbox-edit-control>
                            <wbo-checkbox-edit-control formControlName="displayDefaults"
                                                       [(ngModel)]="model.data.displayDefaults"
                                                       [readonly]="model.data.totalIncluded != undefined">
                            </wbo-checkbox-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
        <fui-rows>
            <fui-row>
                <fui-column [label]="'wbo.extra.edit.field-set.products'">
                    <wbo-edit-grid [data]="model.data.extraProducts" [editable]="true" [removable]="true"
                                   [entityPath]="'extraProducts'" [reorderable]="true">
                        <wbo-sellable-edit-link-column field="productLine.name" componentPath="productLine"
                                                       [editMode]="EditMode.VIEW"></wbo-sellable-edit-link-column>
                        <wbo-currency-column field="price" [editable]="true" [width]="120"></wbo-currency-column>
                        <wbo-numeric-column field="defaultOrderQty" format="1.0-0"
                                            [editable]="true"></wbo-numeric-column>
                        <wbo-numeric-column field="qtyLimit" format="1.0-0" [editable]="true"
                                            [title]="'wbo.extra.edit.column.extraProducts.qtyLimit.title'"
                                            [showPlaceholderForCell]="true"
                                            [placeholder]="'wbo.extra.edit.column.extraProducts.qtyLimit.placeholder'"></wbo-numeric-column>
                        <wbo-checkbox-column field="mixAndMatchDiscountable" [editable]="true"></wbo-checkbox-column>
                        <wbo-checkbox-column field="includeNestedExtras" [editable]="true"></wbo-checkbox-column>
                        <wbo-text-column field="userPrompt" format="1.0-0" [editable]="true"
                                         *ngIf="model.data.conversational"></wbo-text-column>
                        <wbo-edit-grid-add-row (onNewSelect)="selectProductLine([$event])" (onSearchSelect)="selectProductLine($event)" [componentPath]="'productLine'"
                                               [customAdd]="true" [identifierField]="'sellableId'">
                            <wbo-edit-grid-add-row-quick-add>
                                <wbo-product-line-single-select-edit-control>
                                </wbo-product-line-single-select-edit-control>
                            </wbo-edit-grid-add-row-quick-add>
                            <wbo-edit-grid-add-row-actions>
                                <wbo-edit-grid-add-row-search [searchComponent]="ProductLineSearchPageComponent"></wbo-edit-grid-add-row-search>
                                <wbo-edit-grid-add-row-new-entity [editComponent]="ProductLineEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                            </wbo-edit-grid-add-row-actions>
                        </wbo-edit-grid-add-row>
                    </wbo-edit-grid>
                </fui-column>
            </fui-row>
        </fui-rows>
        <fui-rows>
            <fui-row>
                <fui-column [label]="'wbo.extra.edit.field-set.tieredPrices'">
                    <wbo-edit-grid [data]="model.data.extraTieredPrices" [editable]="true" [removable]="true"
                                   [entityPath]="'extraTieredPrices'">
                        <wbo-numeric-column field="qty" format="1.0-0" [editable]="true"></wbo-numeric-column>
                        <wbo-currency-column field="price" [editable]="true"></wbo-currency-column>
                        <wbo-edit-grid-add-row>
                            <wbo-edit-grid-add-row-actions>
                                <wbo-edit-grid-add-row-new></wbo-edit-grid-add-row-new>
                            </wbo-edit-grid-add-row-actions>
                        </wbo-edit-grid-add-row>
                    </wbo-edit-grid>
                </fui-column>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-edit-page>
